
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentContactUsArt: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getContactUsArt({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/ContactUs/GetContactUsArt`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_CONTACT_US_ARTS', response.data.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateContactUsArt({ commit },dataToSend) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/ContactUs/UpdateContactUsArt`,dataToSend);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async getContactUsFields({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/ContactUs//GetFormFieldsText`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_CONTACT_US_FIELDS', response.data.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateContactUsFields({ commit },dataToSend) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/ContactUs/UpdateFormFieldText`,dataToSend);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    
    async setContactUsArt({ commit }, contactUsArt) {
        try {
            await commit('SET_CONTACT_US_ARTS', contactUsArt);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentContactUsArtToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_CONTACT_US_ART',partner);
        await commit('axiosSuccess');
        return true
    },
    async setContactUsFields({ commit }, contactUsFields) {
        try {
            await commit('SET_CONTACT_US_FIELDS', contactUsFields);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentContactUsFieldToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_CONTACT_US_FIELD',partner);
        await commit('axiosSuccess');
        return true
    },
    
    


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
